
import { Language, Translation } from './types';

export const TRANSLATIONS: Record<Language, Translation> = {
  EN: {
    hero: {
      title: "Stealth: Future of Modular Architecture",
      cta1: "Order Now",
      cta2: "Learn More",
      bullet1: "Installation in 3-5 days",
      bullet2: "Payback in 2-3 years",
      bullet3: "Income up to 500 CZK/day",
    },
    header: {
      howItWorks: "Process",
      house: "The House",
      investment: "Investment",
      gallery: "Gallery",
      cases: "Cases",
      blog: "Blog",
      contacts: "Contact",
    },
    calculator: {
      title: "Investment Calculator",
      dailyPrice: "Daily Rental Price (CZK)",
      occupancy: "Annual Occupancy (%)",
      totalRevenue: "Estimated Annual Revenue",
      payback: "Estimated Payback Period",
    }
  },
  UA: {
    hero: {
      title: "Stealth: Майбутнє модульної архітектури",
      cta1: "Замовити будинок",
      cta2: "Дізнатись більше",
      bullet1: "Інсталяція за 3-5 днів",
      bullet2: "Окупність за 2-3 роки",
      bullet3: "Дохід до 500 крон/день",
    },
    header: {
      howItWorks: "Процес",
      house: "Будинок",
      investment: "Інвестиції",
      gallery: "Галерея",
      cases: "Кейси",
      blog: "Блог",
      contacts: "Контакти",
    },
    calculator: {
      title: "Калькулятор інвестицій",
      dailyPrice: "Ціна оренди за добу (крон)",
      occupancy: "Річна завантаженість (%)",
      totalRevenue: "Очікуваний річний дохід",
      payback: "Термін окупності",
    }
  },
  CS: {
    hero: {
      title: "Stealth: Budoucnost modulární architektury",
      cta1: "Objednat dům",
      cta2: "Zjistit více",
      bullet1: "Instalace za 3-5 dní",
      bullet2: "Návratnost za 2-3 roky",
      bullet3: "Zisk až 500 Kč/den",
    },
    header: {
      howItWorks: "Proces",
      house: "Dům",
      investment: "Investice",
      gallery: "Galerie",
      cases: "Případy",
      blog: "Blog",
      contacts: "Kontakt",
    },
    calculator: {
      title: "Investiční kalkulačka",
      dailyPrice: "Denní cena pronájmu (Kč)",
      occupancy: "Roční obsazenost (%)",
      totalRevenue: "Odhadovaný roční příjem",
      payback: "Odhadovaná doba návratnosti",
    }
  },
  DE: {
    hero: {
      title: "Stealth: Zukunft der modularen Architektur",
      cta1: "Haus bestellen",
      cta2: "Mehr erfahren",
      bullet1: "Installation in 3-5 Tagen",
      bullet2: "Amortisation in 2-3 Jahren",
      bullet3: "Einkommen bis zu 500 CZK/Tag",
    },
    header: {
      howItWorks: "Prozess",
      house: "Haus",
      investment: "Investition",
      gallery: "Galerie",
      cases: "Fälle",
      blog: "Blog",
      contacts: "Kontakt",
    },
    calculator: {
      title: "Investitionsrechner",
      dailyPrice: "Mietpreis pro Tag (CZK)",
      occupancy: "Jährliche Auslastung (%)",
      totalRevenue: "Geschätzter Jahresumsatz",
      payback: "Geschätzte Amortisationszeit",
    }
  },
  SK: {
    hero: {
      title: "Stealth: Budúcnosť modulárnej architektúry",
      cta1: "Objednať dom",
      cta2: "Zistiť viac",
      bullet1: "Inštalácia za 3-5 dní",
      bullet2: "Návratnosť za 2-3 roky",
      bullet3: "Zisk až 500 Kč/deň",
    },
    header: {
      howItWorks: "Proces",
      house: "Dom",
      investment: "Investície",
      gallery: "Galéria",
      cases: "Prípady",
      blog: "Blog",
      contacts: "Kontakt",
    },
    calculator: {
      title: "Investičná kalkulačka",
      dailyPrice: "Denná cena prenájmu (Kč)",
      occupancy: "Ročná obsadenosť (%)",
      totalRevenue: "Odhadovaný ročný príjem",
      payback: "Odhadovaná doba návratnosti",
    }
  },
  PL: {
    hero: {
      title: "Stealth: Przyszłość architektury modułowej",
      cta1: "Zamów dom",
      cta2: "Dowiedz się więcej",
      bullet1: "Instalacja w 3-5 dni",
      bullet2: "Zwrot w 2-3 lata",
      bullet3: "Dochód do 500 CZK/dzień",
    },
    header: {
      howItWorks: "Proces",
      house: "Dom",
      investment: "Inwestycje",
      gallery: "Galeria",
      cases: "Przypadki",
      blog: "Blog",
      contacts: "Kontakt",
    },
    calculator: {
      title: "Kalkulator inwestycyjny",
      dailyPrice: "Cena najmu za dobę (CZK)",
      occupancy: "Roczne obłożenie (%)",
      totalRevenue: "Szacowany roczny przychód",
      payback: "Szacowany okres zwrotu",
    }
  }
};
